<script setup lang="ts">
  import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

  const btMobileApp = useCookie<string>('btMobileApp', { path: '/', domain: COOKIE_OPTIONS.domain })
  const hideHeader = computed(() => btMobileApp.value !== undefined)
</script>

<template>
  <MainHeader v-if="!hideHeader" />
  <MainWrapper>
    <main id="main-content">
      <PageTopContent />
      <slot />
    </main>
  </MainWrapper>
  <MainFooter />
</template>
